(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ConsultationReportingController', ConsultationReportingController);

  /* ngInject */
  function ConsultationReportingController(sessionService, consultationService) {
    const vm = this;
    vm.messageThreads = [];
    vm.getMessageThreads = getMessageThreads;

    /* eslint-disable no-undef */
    vm.endAt = moment().format('L');
    vm.startAt = moment().subtract(1, 'months').format('L');
    vm.reportType = 'fi_response_times';
    vm.sessionService = sessionService;
    vm.loading = true;
    vm.totalCount = 9999;
    /* eslint-enable no-undef */

    activate();

    function activate() {
      vm.getMessageThreads();
    }

    function getMessageThreads() {
      vm.loading = true;

      consultationService(sessionService.getAuthToken()).query(response => {
        vm.loading = false;
        vm.messageThreads = response.message_threads;
        vm.totalCount = response.meta.total_count;
      });
    }
  }
})();
